import { Router } from '@angular/router';
import {environment} from '../../../../../environments/environment';


export function onAuthRequiredFunction(oktaAuth: any, injector: any) {
  const router = injector.get(Router);
  // Redirect the user to the custom login page
  if (environment.authLoginInternal) {
    router.navigate(['/login']);
  }/* else {
    const path = oktaAuth.getFromUri();
    oktaAuth.loginRedirect(path.uri);
  }*/
}

export const oktaConfig = {
  issuer: environment.okta_issuer,
  clientId: environment.okta_client_id,
  redirectUri: environment.okta_redirectUri,
  pkce: true,
  scopes: [environment.okta_scope],
  onAuthRequired: onAuthRequiredFunction,
  postLogoutRedirectUri: window.location.origin + '/login'
};
